import { render, staticRenderFns } from "./logistics.vue?vue&type=template&id=b82c3e30&scoped=true"
import script from "./logistics.vue?vue&type=script&lang=ts"
export * from "./logistics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82c3e30",
  null
  
)

export default component.exports